import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuditDashboardComponent } from '../AutonomousMaintenance/audit-dashboard/audit-dashboard.component';
import { AutonomousMaintananceDbComponent } from '../O3AdministrationComponents/autonomous-maintanance-db/autonomous-maintanance-db.component';
import { CrewSchedulingComponent } from '../O3AdministrationComponents/GeneralSettingComponents/crew-scheduling/crew-scheduling.component';
import { MachineParametersComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/machine-parameters/machine-parameters.component';
import { OeeConfigurationComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/oee-configuration/oee-configuration.component';
import { SfdcConfigurationComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/sfdc-configuration/sfdc-configuration.component';
import { ProductionDbComponent } from '../O3AdministrationComponents/production-db/production-db.component';
import { OrderProcessingComponent } from '../ProductionOrderComponents/order-processing/order-processing.component';
import { ShopFloorDataComponent } from '../ProductionOrderComponents/shop-floor-data/shop-floor-data.component';
import { AuthGuard } from '../services/auth.guard';
import { MachineboardComponent } from './analytics/machineboard/machineboard.component';
import { AvailabilityAnalysisComponent } from './availability-analysis/availability-analysis.component';
// import { CheckListComponent } from './check-List/check-List.component';
import { CuAnalysisComponent } from './cu-analysis/cu-analysis.component';
import { HomeComponent } from './home/home.component';
import { PlantModelComponent } from './home/plant-model/plant-model.component';
import { UseraccessComponent } from './home/useraccess/useraccess.component';
import { PerformanceAnalysisComponent } from './performance-analysis/performance-analysis.component';
import { QualityAnalysisComponent } from './quality-analysis/quality-analysis.component';
import { QualityDbComponent } from './quality-db/quality-db.component';
import { SafetyDbComponent } from './safety-db/safety-db.component';
import { GeneralCategoryComponent } from '../General Category/general-category/general-category.component';
import { BatchReportComponent } from './batch-report/batch-report.component';
import { WholesomeFoodReportComponent } from './wholesome-food-report/wholesome-food-report.component';
import { EventConfigurationComponent } from '../O3AdministrationComponents/ManufacturingAdminComponents/event-configuration/event-configuration/event-configuration.component';
import { BatchReportOutputComponent } from './batch-report-output/batch-report-output.component';
import { SfdcNewComponent } from '../ProductionOrderComponents/sfdc-new/sfdc-new.component';
import { LanguageMasterComponent } from './language-master/language-master.component';
import { PalletComponent } from './pallet/pallet.component';
import { ProductCostConfigurationComponent } from './product-cost-configuration/product-cost-configuration.component';
import { CitiesAndCountriesComponent } from '../O3AdministrationComponents/CitiesAndCountries/CitiesAndCountries.component';
import { KpiTargetDownloadComponent } from './kpi-target-download/kpi-target-download.component';
// import { CustomerProfileUploadComponent } from '../quality-management/ncr-ccr-management/customerProfileUpload/customerProfileUpload.component';
// import { CustomerSurveyComponent } from '../quality-management/ncr-ccr-management/customer-survey/customer-survey.component';
// import { ImmediateActionComponent } from '../quality-management/ncr-ccr-management/immediate-action/immediate-action.component';
import { UserActionsComponent } from '../user-actions/user-actions.component';
import { InputReportComponent } from './input-report/input-report.component';
import { UserLicenseComponent } from '../O3AdministrationComponents/user-license/user-license.component';
import { GroupLicenseComponent } from '../O3AdministrationComponents/group-license/group-license.component';
// import { CustomerSurveyDbComponent } from '../quality-management/ncr-ccr-management/customer-survey-db/customer-survey-db.component';
import { ErpPlantMappingComponent } from './erp-plant-mapping/erp-plant-mapping.component';
import { ErpMachineMappingComponent } from './erp-machine-mapping/erp-machine-mapping.component';
import { ErpProductionOrderComponent } from './erp-production-order/erp-production-order.component';
// import { SortingReportComponent } from '../quality-management/ncr-ccr-management/sorting-report/sorting-report.component';
import { WhatAppConfigComponent } from '../O3AdministrationComponents/what-app-config/what-app-config.component';
import { WasteDetailComponent } from '../ProductionOrderComponents/waste-detail/waste-detail.component';
import { FormViewerComponent } from './form-viewer/form-viewer.component';
import { DropdownOperationService } from '../services/dropdown-operation.service';
import { ListOperationService } from '../services/list-operation.service';
const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'Index', component: HomeComponent, canActivate: [AuthGuard] },
  {
    path: 'PlantModel',
    component: PlantModelComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'OeeConfiguration',
    component: OeeConfigurationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'Planner',
    component: OrderProcessingComponent,
    canActivate: [AuthGuard],
  },
  { path: 'userActions', component: UserActionsComponent, canActivate: [AuthGuard] },
  // {path: 'NewSfdc', component: NewSfdcComponent, canActivate: [AuthGuard] },
  { path: 'SFDC', component: ShopFloorDataComponent, canActivate: [AuthGuard] },
  {
    path: 'SFDCConfiguration',
    component: SfdcConfigurationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'MachineDashboard',
    component: MachineboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'VariableManagement',
    component: MachineParametersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'CrewSchedule',
    component: CrewSchedulingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'UserAcessList',
    component: UseraccessComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'WhatAppConfig',
    component: WhatAppConfigComponent,
    canActivate: [AuthGuard],
  },
  // { path: 'CheckList', component: CheckListComponent },
  { path: 'ProductionDB', component: ProductionDbComponent },
  { path: 'MachineBoard', component: MachineboardComponent },
  { path: 'CuAnalysis', component: CuAnalysisComponent },
  { path: 'AvailbilityAnalysis', component: AvailabilityAnalysisComponent },
  { path: 'AuditDashboard', component: AuditDashboardComponent },
  { path: 'generalcategory', component: GeneralCategoryComponent },
  { path: 'waste', component: WasteDetailComponent },
  { path: 'PerformanceAnalysis', component: PerformanceAnalysisComponent },
  { path: 'SafetyDB', component: SafetyDbComponent },
  { path: 'QualityDB', component: QualityDbComponent },
  { path: 'AutonomusDB', component: AutonomousMaintananceDbComponent },
  { path: 'QualityAnalysis', component: QualityAnalysisComponent },
  { path: 'BatchReport', component: BatchReportComponent },
  { path: 'BatchReportOutput', component: BatchReportOutputComponent },
  { path: 'wholesomefoodreport', component: WholesomeFoodReportComponent },
  { path: 'EventConfiguration', component: EventConfigurationComponent },
  { path: 'productionStart', component: SfdcNewComponent },
  { path: 'languagemaster', component: LanguageMasterComponent },
  { path: 'Pallet', component: PalletComponent },
  {
    path: 'productCostConfiguration',
    component: ProductCostConfigurationComponent,
  },
  { path: 'CitiesAndCountries', component: CitiesAndCountriesComponent },
  { path: 'KPItargetdownload', component: KpiTargetDownloadComponent },
  // { path: 'CustomerProfileUpload', component: CustomerProfileUploadComponent },
  // { path: 'CustomerSurvey', component: CustomerSurveyComponent },
  // { path: 'ImmediateAction', component: ImmediateActionComponent },
  {
    path: 'productCostConfiguration',
    component: ProductCostConfigurationComponent,
  },
  { path: 'KPItargetdownload', component: KpiTargetDownloadComponent },
  { path: 'InputReport', component: InputReportComponent },
  { path: 'userLicense', component: UserLicenseComponent },
  { path: 'GroupLicense', component: GroupLicenseComponent },
  // { path: 'CustomerSurveyDb', component: CustomerSurveyDbComponent },

  { path: 'erpPlantMapping', component: ErpPlantMappingComponent },
  { path: 'erpMachineMapping', component: ErpMachineMappingComponent },
  { path: 'erpProductionOrder', component: ErpProductionOrderComponent },
  // { path: 'SortingReport', component: SortingReportComponent },
  {
    path: 'form-viewer',
    component: FormViewerComponent,
  }

];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers : [DropdownOperationService,ListOperationService]
})
export class HomeRoutingModule { }
